import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import usePageTitle from '../hooks/usePageTitle';
import WaitlistSection from '../components/WaitlistSection';
import Hero from '../components/home/Hero';
import PainPoints from '../components/home/PainPoints';
import StructuredPath from '../components/home/StructuredPath';
import Programs from '../components/home/Programs';
import FounderStory from '../components/home/FounderStory';

const Home = () => {
  usePageTitle('Home');
  const location = useLocation();
  const [prefill, setPrefill] = useState({ courseInterest: '', message: '' });

  const scrollToWaitlist = useCallback(() => {
    document.getElementById('waitlist')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, []);

  // location.key changes on every navigation, so repeat clicks on a
  // "/#waitlist" link scroll again instead of doing nothing.
  useEffect(() => {
    if (location.hash !== '#waitlist') return undefined;
    const timer = setTimeout(scrollToWaitlist, 100);
    return () => clearTimeout(timer);
  }, [location.hash, location.key, scrollToWaitlist]);

  const handleProgramWaitlist = (courseTitle) => {
    setPrefill((prev) => ({ ...prev, courseInterest: courseTitle }));
    scrollToWaitlist();
  };

  return (
    <div className="min-h-screen bg-black film-grain">
      <Hero />

      <div className="film-strip w-full" />

      <PainPoints />
      <StructuredPath />
      <Programs onWaitlist={handleProgramWaitlist} />
      <FounderStory />

      <div className="film-strip w-full" />

      <WaitlistSection
        sectionId="waitlist"
        chapterLabel="Join the waitlist"
        className="scroll-mt-24 bg-black py-20 md:py-28"
        defaultCourseInterest={prefill.courseInterest}
        defaultMessage={prefill.message}
      />
    </div>
  );
};

export default Home;
